import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button,Checkbox } from "@mui/material";

import {
  VerifyAccountAction,
  VerifyEmailAction,
  ClearAuthResponse,
} from "../../Redux/Actions/AuthActions";
import "./style.css";
import { useParams, useNavigate } from "react-router";
import logo from "../../Assets/Images/logo.png";
import { Link } from "react-router-dom";
import ResponsiveDialog from "../../Components/DialogBox";
export const VerifyAccount = () => {
  //state
  const [allow, setAllow] = useState(false);
  const [accept, setAccept] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //taking token nd value for differentiate which api call's
  const { token, value } = useParams();

  //reducer data
  const { success, message } = useSelector((state) => state?.Auth);

  //action call
  useEffect(() => {
    if (value && token && value === "emailVerification") {
      dispatch(VerifyEmailAction(token));
    } else if (value && token && value === "invited" && accept && allow) {
      dispatch(VerifyAccountAction(token));
    }
  }, [value, token, accept, allow]);

  useEffect(() => {
    dispatch(ClearAuthResponse());
  }, [dispatch]);

  return (
    <>
      {value === "emailVefication" ? (
        success === true || message === " Invalid user!" ? (
          navigate("/")
        ) : (
          <h2
            className={
              message === "Invalid Token!"
                ? "verify_account_title_fail"
                : "verify_account_title"
            }
          >
            {message}
          </h2>
        )
      ) : value === "invited" && accept && allow ? (
        <h2
          className={
            message === "Invalid Token!"
              ? "verify_account_title_fail"
              : "verify_account_title"
          }
        >
          {message}
        </h2>
      ) : value === "invited" && !accept ? (
        <Box className="forget-passwordForm">
          <ResponsiveDialog
            open={isVisibleModal}
            header="You need to allow us to continue,please check the box indicating your consent."
            dtype="msg"
            onClose={() => setIsVisibleModal(false)}
          ></ResponsiveDialog>
          <Box className="form-contianer">
            <Box className="logo">
              <img src={logo} className="brand-logo" alt=""></img>
            </Box>

            <Box className="input forget-password-input">
              <Box
                sx={{
                  textAlign: "center",
                  fontSize: "24px",                
                }}
              >
                <Checkbox
                  onChange={() => {
                    setAllow(!allow);
                  }}
                  sx={{ height: "30px", width: "30px" }}
                />{" "}
                I consent to the Oncio app sharing data about my health (as
                described in the{" "}
                <Link to="http://18.197.124.204:3002/privacy-policy">
                  Privacy Notice
                </Link>
                ) with my health care provider as confirmed by me.
                {}
              </Box>
            </Box>
            <Box className="invite-btns">
              <Button
                onClick={() =>
                  allow ? setAccept(true) : setIsVisibleModal(true)
                }
                variant="contained"
                color="success"
              >
                Accept
              </Button>
              <Button
                variant="contained"
                onClick={() => (window.location.href = "https://www.oncio.org")}
                color="error"
              >
                Reject
              </Button>
            </Box>
          </Box>
        </Box>
      ) : (
        ""
      )}
    </>
  );
};
